export const environment = {
  version: '0.61',
  production: true,
  apiUrl: '/api/',
  modeDebug: true,
  domain: 'localhost',
  changelog: false
};
